import styled from 'styled-components'
import { colors, device } from 'Styled/variables'
import { Link } from 'react-router-dom'

export const StyledDottedBtnOrange = styled.button`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: ${colors.messegesYellow1};
  border-bottom: 1px dashed #f19236;
  background-color: transparent;
  padding-bottom: 4px;
  margin-right: 16px;
  padding-top: 0px;
  padding-left: 0px;
  padding-right: 0px;
`

export const StyledDottedBtn = styled(Link)`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  color: ${colors.mainText};
  &:hover,
  &:visited {
    color: ${colors.mainText};
  }
  padding-bottom: 2px;
  border-bottom: 1px dashed #646877;
`

export const EmptyCampaignsContentWrapper = styled.div`
  background: white;
  border-radius: 5px;
  padding: 100px 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media ${device.mobileMax} {
    padding: 50px 45px;
  }
`

export const EmptyCampaignsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  row-gap: 30px;
  margin: 0 auto;
`
